import React from "react";

import "./style.scss";

import { Box } from "app/layout/Box/Box";
import { Headline, VisualHeadlineSize } from "app/layout/Headline/Headline";
import { AttributeList } from "app/layout/AttributeList/AttributeList";

export interface Props {
    /** Title of the share to be printed as headline */
    name: string;
    attributes: string[];
}

/**
 * This component renders the share name as main headline
 * as well as a list of attributes for the share.
 */
export const PageHeader = ({ name, attributes }: Props) => {
    return (
        <Box className="shareHeader">
            <h1>
                <Headline visualSize={VisualHeadlineSize.LARGE} semanticSize={0}>
                    <span>{name}</span>
                </Headline>
                {attributes && <AttributeList items={attributes} />}
            </h1>
        </Box>
    );
};
